// extracted by mini-css-extract-plugin
export default {"titleWithIcon":"title-with-icon_titleWithIcon__FVsa9","title":"title-with-icon_title__8ElhH","icon":"title-with-icon_icon__0b-G0"};